import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="versicherte-person"
export default class extends Controller {
	static targets = ["hiddenType"]
	connect() {}

	updatePerson({ currentTarget }) {
		const selectedOption = currentTarget.selectedOptions[0]
		this.hiddenTypeTarget.value = selectedOption.dataset.type
	}
}
